import React, { useState } from 'react'
import './NylasScheduler.css'
import Loader from '../../../Component/Loader'

function NylasScheduler(props) {
  const [loading, setLoading] = useState(true)

  return (
    <div className="nylas-scheduler-wrapper">
      {loading && <Loader />}
      <iframe
        className="nylas-scheduler-iframe"
        title="nylas-scheduler-iframe"
        src={props.url}
        onLoad={() => setLoading(false)}
      />
    </div>
  )
}

export default NylasScheduler
